import {
  Box,
  Button,
  Dialog,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core";
import cross from "../../assets/images/cross.svg";
import useStyles from "../Styles/ProjectModalStyles";
import Lottie from "lottie-react";
import Animation from "../../assets/animations/StakingRequired.json";
import { Link } from "react-router-dom";

const StakingRequiredModal = ({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (value: boolean) => void;
}) => {
  const theme = useTheme();
  const isActive = useMediaQuery(theme.breakpoints.down("sm"));
  const classes = useStyles();

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Box component="section">
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className={` ${classes.stakingModal}`}
        >
          {!isActive && (
            <img
              src={cross}
              alt=""
              className="cross-icon"
              onClick={handleClose}
            />
          )}
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
          >
            <Lottie
              animationData={Animation}
              style={{
                width: "192px",
                height: "185",
              }}
            />
            <Typography
              style={{
                fontSize: "1.625rem",
                color: "rgba(17, 48, 45, 1)",
                fontWeight: 700,
              }}
            >
              Staking Required
            </Typography>
            <Typography
              className="text-center"
              style={{ marginTop: "1.5rem", padding: isActive ? "0 1rem" : 0 }}
            >
              In order to invest in the upcoming IDO opportunities, you need to
              stake some GAINS Tokens
            </Typography>
            <Box
              display="flex"
              width={"100%"}
              justifyContent="center"
              marginTop="1.5rem"
            >
              <Link
                to="/gains"
                style={{
                  textDecoration: "none",
                  width: isActive ? "50%" : "60%",
                }}
              >
                <Button
                  style={{ width: "100%" }}
                  variant="contained"
                  color="secondary"
                  size="small"
                  classes={{ label: "fs12" }}
                >
                  Stake $GAINS
                </Button>
              </Link>
              <Link to="/ido-step-by-step" style={{ textDecoration: "none" }}>
                <Button
                  fullWidth
                  variant="contained"
                  style={{
                    backgroundColor: "transparent",
                    color: "rgba(17, 48, 45, 1)",
                    border: "1px solid rgba(17, 48, 45, 0.2)",
                    marginLeft: "1rem",
                  }}
                  size="small"
                  classes={{ label: "fs12" }}
                >
                  Learn More
                </Button>
              </Link>
            </Box>
          </Box>
        </Dialog>
      </Box>
    </>
  );
};

export default StakingRequiredModal;
